import { useEffect, useState } from "react";
import { Rocket } from "lucide-react";
import { api } from "@/lib/api";

const fmt = (iso) => new Date(iso).toLocaleDateString("en-AU", { day: "numeric", month: "short" });

export function LaunchStats() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/launch-stats").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  const max = Math.max(1, ...s.daily.map((d) => d.signups + d.listings));
  const tiles = [["New sign-ups", s.signups, "signups"], ["New listings", s.listings, "listings"], ["Items sold", s.sold, "sold"], ["Messages sent", s.messages, "messages"], ["Waitlist joins", s.waitlist, "waitlist"]];
  const live = new Date(s.end) > new Date();

  return (
    <section data-testid="launch-stats-card" className="mt-6 rounded-3xl bg-[#173742] p-6">
      <div className="flex flex-wrap items-center gap-3">
        <Rocket className="h-6 w-6 text-[#d4f253]" />
        <h2 className="font-display text-xl font-bold">Launch week</h2>
        <span className="text-sm text-slate-400">{fmt(s.start)} – {fmt(s.end)}</span>
        <span className={`rounded-full px-2.5 py-0.5 text-[10px] font-bold uppercase ${live ? "bg-[#d4f253] text-[#0f2a33]" : "bg-white/10"}`}>{live ? "Live now" : "Finished"}</span>
        <span className="ml-auto text-xs text-slate-400">All time: {s.total_users} member{s.total_users === 1 ? "" : "s"} · {s.active_listings} items for sale</span>
      </div>
      <div className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-5">
        {tiles.map(([label, v, k]) => (
          <div key={k} className="rounded-2xl bg-[#0f2a33] px-4 py-3">
            <p data-testid={`launch-stat-${k}`} className="font-display text-3xl font-extrabold text-[#d4f253]">{v}</p>
            <p className="text-xs text-slate-400">{label}</p>
          </div>
        ))}
      </div>
      <div className="mt-5 flex h-24 items-end gap-2" data-testid="launch-stats-chart">
        {s.daily.map((d) => (
          <div key={d.day} className="flex flex-1 flex-col items-center gap-1" title={`${d.signups} sign-ups, ${d.listings} listings`}>
            <div className="flex w-full flex-col justify-end overflow-hidden rounded-md bg-[#0f2a33]" style={{ height: "72px" }}>
              <div className="bg-[#d4f253]/50" style={{ height: `${(d.listings / max) * 100}%` }} />
              <div className="bg-[#d4f253]" style={{ height: `${(d.signups / max) * 100}%` }} />
            </div>
            <span className="text-[10px] text-slate-500">{fmt(d.day)}</span>
          </div>
        ))}
      </div>
      <p className="mt-2 text-[11px] text-slate-500"><span className="mr-1 inline-block h-2 w-2 rounded-sm bg-[#d4f253]" />Sign-ups <span className="ml-3 mr-1 inline-block h-2 w-2 rounded-sm bg-[#d4f253]/50" />Listings (sample listings not counted)</p>
    </section>
  );
}
